import styled from "styled-components";
import Col from "../../UIcomponent/Column";

export const DashboardLayout = styled(Col)`
  flex-direction: column;
  margin-top: 100px;
  padding-bottom: 70px;
  min-height: 100vh;
  max-width: 100vw !important;
  justify-content: flex-start !important;
  @media screen and (max-width: 992px) {
    .l__Dashboard {
      margin-right: 0px;
    }
  }
  @media screen and (max-width: 768px) {
    margin-top: 0;
    padding-bottom: 0px;
  }
`;
